import { createContext, createElement, type PropsWithChildren, type ReactElement, useContext } from 'react';
import { type ConsentPolicy, DEFAULT_CONSENT_POLICY } from '@/lib/consent-policy';

const ConsentPolicyContext = createContext<ConsentPolicy>(DEFAULT_CONSENT_POLICY);

export function ConsentPolicyProvider({
    policy,
    children,
}: PropsWithChildren<{ policy: ConsentPolicy }>): ReactElement {
    return createElement(ConsentPolicyContext.Provider, { value: policy }, children);
}

export function useConsentPolicy(): ConsentPolicy {
    return useContext(ConsentPolicyContext);
}
